import { core_v1_Rule } from '@antimatterhq/asl-api-ts-v1';
import { Fieldset } from '@antimatterhq/ui/components/fieldset';
import Spacer from '@antimatterhq/ui/components/spacer';

interface ObservablesReviewProps {
  rule: core_v1_Rule;
}

export function ObservablesReview({ rule }: ObservablesReviewProps) {
  const observables = rule.spec.observables || [];

  return (
    <div>
      {observables.map((observable, index) => (
        <div key={index}>
          {index > 0 && <Spacer size="xl" />}

          <div>
            <Fieldset.Field>
              <Fieldset.Label>{observable.kind}</Fieldset.Label>
            </Fieldset.Field>
            <Fieldset.List>
              <Fieldset.Field>
                <Fieldset.Label>
                  <span className="whitespace-nowrap">Value:</span>
                </Fieldset.Label>
                <Fieldset.Value>
                  <div className="max-w-[600px] truncate">
                    {observable.value || <span className="italic">[none]</span>}
                  </div>
                </Fieldset.Value>
              </Fieldset.Field>

              <Fieldset.Field>
                <Fieldset.Label>
                  <span className="whitespace-nowrap">Relationship:</span>
                </Fieldset.Label>
                <Fieldset.Value>
                  <div className="max-w-[600px] truncate">
                    {observable.relationship || (
                      <span className="italic">[none]</span>
                    )}
                  </div>
                </Fieldset.Value>
              </Fieldset.Field>

              <Fieldset.Field>
                <Fieldset.Label>
                  <span className="whitespace-nowrap">Impact:</span>
                </Fieldset.Label>
                <Fieldset.Value>
                  <div className="max-w-[600px] truncate">
                    {observable.risk?.impact || (
                      <span className="italic">[none]</span>
                    )}
                  </div>
                </Fieldset.Value>
              </Fieldset.Field>

              <Fieldset.Field>
                <Fieldset.Label>
                  <span className="whitespace-nowrap">Confidence:</span>
                </Fieldset.Label>
                <Fieldset.Value>
                  <div className="max-w-[600px] truncate">
                    {observable.risk?.confidence || (
                      <span className="italic">[none]</span>
                    )}
                  </div>
                </Fieldset.Value>
              </Fieldset.Field>
            </Fieldset.List>
          </div>
        </div>
      ))}

      {observables.length === 0 && (
        <Fieldset.Value>
          <span className="italic">[none]</span>
        </Fieldset.Value>
      )}
    </div>
  );
}
